
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".344","width":"18","height":"18","rx":"4","fill":"#EBEBEB"}}),_c('path',{attrs:{"d":"M6.285 13.934c-.42 0-.63-.21-.63-.63v-8.61c0-.42.21-.63.63-.63h3.318c1.017 0 1.801.23 2.352.686.56.448.84 1.078.84 1.89 0 .542-.14 1.004-.42 1.386-.28.383-.668.663-1.162.84.57.15 1.012.425 1.33.826.326.402.49.91.49 1.527 0 .877-.285 1.549-.854 2.016-.57.466-1.372.7-2.408.7H6.285zm.49-5.46h2.66c1.484 0 2.226-.578 2.226-1.736 0-1.166-.742-1.75-2.226-1.75h-2.66v3.486zm0 4.537h2.884c1.493 0 2.24-.602 2.24-1.806 0-1.204-.747-1.807-2.24-1.807H6.775v3.613z","fill":"#000"}})])
          )
        }
      }
    